import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const MixedFleet: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m77.27 570h341.97v30h-341.97z' />
    <path d='m405 720c-8.28 0-15-6.72-15-15v-115.78l-48.45-79.19c-.15-.02-.33-.04-.54-.04h-202.08c-.18 0-.35.02-.49.04l-48.45 79.19v11.24c0 8.28-6.72 15-15 15s-15-6.72-15-15v-15.46c0-2.76.76-5.47 2.21-7.83l51.37-83.96c4.91-8.12 14.61-13.18 25.32-13.21h202.17c10.76.03 20.45 5.09 25.37 13.21l51.37 83.96c1.44 2.36 2.21 5.07 2.21 7.83v120c0 8.28-6.72 15-15 15z' />
    <path d='m0 600h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m300 660h60s0-30 0-30h-30c-16.57 0-30 13.43-30 30z' />
    <path d='m180 660h-60s0-30 0-30h30c16.57 0 30 13.43 30 30z' />
    <path d='m180 390v-90s-30 0-30 0v60c0 16.57 13.43 30 30 30z' />
    <path d='m480 420h-180s0-30 0-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m480 600h-90s0-30 0-30h60c16.57 0 30 13.43 30 30z' />
    <path d='m60 595h30v95h-30z' />
    <path d='m170 690h150v30h-150z' />
    <path d='m420 780h-82.5c-20.68 0-37.5-15.55-37.5-34.67v-55.33h30v55.33c0 2.16 3.28 4.67 7.5 4.67h52.5v-40.72h30z' />
    <path d='m142.5 780h-82.5v-95h30v65h52.5c4.22 0 7.5-2.51 7.5-4.67v-55.33h30v55.33c0 19.12-16.82 34.67-37.5 34.67z' />
    <path d='m378.28 60h333.15v30h-333.15z' />
    <path d='m376 150h333.15v30h-333.15z' />
    <path d='m600 270h30v30h-30z' />
    <path d='m720 292.97h-30v-229.05c0-18.7-16.49-33.92-36.76-33.92h-226.47c-20.27 0-36.76 15.22-36.76 33.92v116.08h-30v-116.08c0-35.25 29.95-63.92 66.76-63.92h226.47c36.81 0 66.76 28.67 66.76 63.92z' />
    <path d='m720 360h-85.31c-19.13 0-34.69-15.56-34.69-34.69v-37.03h30v37.03c0 2.58 2.1 4.69 4.69 4.69h55.31v-40.78h30z' />
    <circle cx='611.25' cy='223.75' r='18.75' />
    <path d='m330 180v-120s-30 0-30 0v90c0 16.57 13.43 30 30 30z' />
    <path d='m750 180v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m235 330h325v30h-325z' />
    <path d='m210.75 355h30v95h-30z' />
    <path d='m390 450h80.75v30h-80.75z' />
    <path d='m570.75 540h-82.5c-20.68 0-37.5-15.55-37.5-34.67v-55.33h30v55.33c0 2.16 3.28 4.67 7.5 4.67h52.5v-40.72h30z' />
    <path d='m570.75 475h-30v-130.99l-19.8-104.01h-260.37l-19.84 104.02v105.98h-30v-108.82l21.17-111.02.31-.93c3.8-11.5 14.46-19.23 26.52-19.23h264c12.39 0 23.13 8 26.73 19.9l.23.76 21.04 110.52v133.82z' />
  </IconBase>
));

MixedFleet.displayName = 'MixedFleet';

export default MixedFleet;
